module.exports = __webpack_public_path__ + "img/slider_bg_phone.ca4ce5f6.png";